export default "__VITE_ASSET__znCwCaHo__"